const BROKER_ACCOUNT_BASE_PATH = "/api/algotrade/broker-accounts";

export const BrokerApiUrl = {
  basePath: BROKER_ACCOUNT_BASE_PATH,
  addBroker: "/add-broker",
  updateBroker: (id) => `/update-broker/${encodeURIComponent(id)}`,
  getAllBrokersByType: "/get-all-broker-by-type",
  getBrokerByUserId: "/get-broker-by-user-id",
  deleteBrokerByUserId: "/delete-broker-by-user-id",
  connectBroker: "/connect-broker",
  disconnectBroker: "/disconnect-broker",
};
